import React, { useState, useEffect, useRef } from "react";
import { Container, Card, Button, Form, Nav } from "react-bootstrap";
import axios from "axios";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

const Documents = ({ person_id }) => {
  const downloadLinkRef = useRef(null);
  const navigate = useNavigate();
  const BaseUrl = process.env.REACT_APP_API;
  const [documents, setDocuments] = useState([]);
  const [forms, setForms] = useState([
    { selectedFile: null, fileDescription: "" },
  ]);
  const [activeTab, setActiveTab] = useState("clientUploaded");

  const crumbs = [
    { title: "Home", link: "/admin/ind/user" },
    { title: "Documents" },
  ];

  useEffect(() => {
    fetchDocuments();
    // eslint-disable-next-line
  }, [BaseUrl, person_id]);

  const fetchDocuments = async () => {
    try {
      const response = await axios.post(`${BaseUrl}/getIndividualDocuments`, { person_id });

      // Filter out unwanted fields (created_at, updated_at, document, document_id)
      const filteredDocuments = response.data
        .filter(
          (doc) =>
            doc.client_uploaded_file !== null &&
            doc.client_uploaded_file !== undefined
        )
        .map((doc) => ({
          message: doc.message,
          client_uploaded_file: doc.client_uploaded_file,
        }));

      setDocuments(filteredDocuments);
    } catch (error) {
      console.error(error.message || "Error fetching documents");
    }
  };

 
  const handleDownload = async (filename, person_id) => {

    const response = await fetch(`${BaseUrl}/download/documents/${filename}?person_id=${person_id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      toast.success("File downloaded successfully.");

      // Create a temporary anchor element to trigger the download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(new Blob([blob]));
      // Ensure downloadLinkRef.current is not null before accessing its properties
      if (downloadLinkRef.current) {
        downloadLinkRef.current.href = url;
        downloadLinkRef.current.setAttribute("download", filename);
        downloadLinkRef.current.click();
      } else {
        console.error("downloadLinkRef.current is null");
      }
    } else {
      return;
    }
  };
  
  const handleUploadSubmit = async (formIndex) => {
    const { selectedFile, fileDescription } = forms[formIndex];

    if (!selectedFile) {
      toast.error("Please select a file to upload.");
      return;
    }

    if (!fileDescription.trim()) {
      toast.error("Please provide a description for the file.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("person_id", person_id);
      formData.append("description", fileDescription);
      formData.append("document", selectedFile);
      const response = await axios.post(
        `${BaseUrl}/uploadIndividualDocumentAdmin`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      if (response.data.success) {
        toast.success("File uploaded successfully.");
        setForms((prevForms) => {
          const updatedForms = [...prevForms];
          updatedForms[formIndex] = { selectedFile: null, fileDescription: "" };
          return updatedForms;
        });
        fetchDocuments();
      } else {
        toast.error("Failed to upload file.");
      }
    } catch (error) {
      console.error("Error uploading file:", error);
      toast.error("An error occurred while uploading the file.");
    }
  };

  const handleFileChange = (event, formIndex) => {
    const selectedFile = event.target.files[0];
    setForms((prevForms) => {
      const updatedForms = [...prevForms];
      updatedForms[formIndex] = { ...updatedForms[formIndex], selectedFile };
      return updatedForms;
    });
  };

  const handleDescriptionChange = (event, formIndex) => {
    const fileDescription = event.target.value;
    setForms((prevForms) => {
      const updatedForms = [...prevForms];
      updatedForms[formIndex] = { ...updatedForms[formIndex], fileDescription };
      return updatedForms;
    });
  };

  const handleTabSelect = (tabKey) => {
    setActiveTab(tabKey);
  };



  const [isReadOnly, setReadOnly] = useState(false);
  


  return (
    <>
    
      <div className="main-content" style={{ padding: "25px" }}>
        <Container fluid>

          <Card
            className="mx-auto"
            style={{
              borderRadius: "15px",
              maxWidth: "800px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              marginBottom: "60px",
            }}
          >
            <Card.Body>
              <Nav
                variant="tabs"
                activeKey={activeTab}
                className="responsive-tabs"
              >
                {/* <Nav.Item>
                  <Nav.Link
                    eventKey="adminUploaded"
                    onClick={() => handleTabSelect("adminUploaded")}
                    className={`tab-link ${
                      activeTab === "adminUploaded" ? "active" : ""
                    }`}
                  >
                    Admin Uploaded
                  </Nav.Link>
                </Nav.Item> */}
                <Nav.Item>
                  <Nav.Link
                    eventKey="clientUploaded"
                    onClick={() => handleTabSelect("clientUploaded")}
                    className={`tab-link ${
                      activeTab === "clientUploaded" ? "active" : ""
                    }`}
                  >
                    Client Uploaded
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              {/* {activeTab === "adminUploaded" && (
                <>
                  {forms.map((form, index) => (
                    <Form key={index} style={{ marginTop: "20px" }} >
                      <h5>File {index + 1}</h5>
                      <Form.Group controlId={`formFileDescription_${index}`} >
                        <Form.Label
                          style={{ marginBottom: "10px", display: "block" }}
                        >
                          File Description
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={3}
                          value={form.fileDescription}
                          onChange={(event) =>
                            handleDescriptionChange(event, index)
                          }
                          style={{
                            borderRadius: "8px",
                            border: "1px solid #ced4da",
                          }}
                          placeholder="Enter a description for the file..."
                        />
                      </Form.Group>
                      <Form.Group
                        controlId={`formFile_${index}`}
                        className="mt-3"
                      >
                        <Form.Label
                          style={{ marginBottom: "10px", display: "block" }}
                        >
                          Select file to upload
                        </Form.Label>
                        <Form.Control
                          type="file"
                          onChange={(event) => handleFileChange(event, index)}
                          style={{ border: "1px solid #ced4da" }}
                        />
                      </Form.Group>
                      {index < forms.length - 1 && <hr />}
                    </Form>
                  ))}
                  <div style={{ marginTop: "20px", textAlign: "right" }}>
                    <Button
                      hidden = {isReadOnly}
                      variant="primary"
                      className="upload-button"
                      onClick={() => handleUploadSubmit(forms.length - 1)}
                    >
                      Upload
                    </Button>
                    <Button
                      hidden ={isReadOnly}
                      variant="secondary"
                      className="add-button"
                      onClick={() =>
                        setForms((prevForms) => [
                          ...prevForms,
                          { selectedFile: null, fileDescription: "" },
                        ])
                      }
                    >
                      Add +
                    </Button>
                  </div>
                </>
              )} */}

              {activeTab === "clientUploaded" && (
                <>
                  {documents.length > 0 ? (
                    <>
                      {documents.map((doc, index) => (
                        <Card key={index} className="document-card mb-3">
                          <Card.Body>
                            {Object.entries(doc).map(([key, value]) => (
                              <div key={key} className="document-field">
                                <strong>
                                  {key === "message"
                                    ? "Remark"
                                    : key === "client_uploaded_file"
                                    ? "Filename"
                                    : key.toUpperCase()}
                                  :{" "}
                                </strong>{" "}
                                {value}
                              </div>
                            ))}
                            <Button
                              hidden ={isReadOnly}
                              variant="primary"
                              onClick={() =>
                                handleDownload(
                                  doc.client_uploaded_file, person_id
                                )
                              }
                            >
                              Download
                            </Button>
                          </Card.Body>
                        </Card>
                      ))}{" "}
                    </>
                  ) : (
                    <div className="container mt-4">
                      <div className="row justify-content-center">
                        <div className="col-6" style={{ width: "100%" }}>
                          <div className="card">
                            <div className="card-body text-center font-weight-bold">
                              No File Uploaded
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              )}
              <a
                ref={downloadLinkRef}
                style={{ display: "none" }}
                href={() => false}
              ></a>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default Documents;
